<template>
  <div class="question" :style="{ height: height + 'px' }">
    <div :style="{ height: ( height - 20 ) + 'px' }" class="content">
      <div class="rolling">
        <ul class="ul">
          <li @click="question(item.id)" v-for="(item,index) in info" :key="index">
            <h5 class="line-clamp-1">{{item.title}}</h5>
            <p>
              <span>{{item.username}}</span>
              发布于{{item.create_time}}分钟前 &nbsp;&nbsp;·&nbsp;&nbsp;
              <span>{{item.answer_num}}回复</span>
            </p>
          </li>
        </ul>
      </div>
      <el-input
        type="textarea"
        class="textarea"
        placeholder="请输入内容"
        v-model="textarea">
      </el-input>
      <div @click="sure" class="sure fr">确定</div>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      height: {
        type: Number,
        default: 3.5
      }
    },
    data () {
      return {
        id: '',
        textarea: '',
        info: {}
      }
    },
    created () {
      this.getdata()
    },
    methods: {
      question (id) {
        this.$store.state.pxInterlocutionId = id
        this.$emit('changIndex', 4)
      },
      getdata () {
        this.$http.post('/apipx/Lesson/interlocutioninfo', {
          lesson_id: this.$parent.id,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          this.info = res.data
        })
      },
      sure () {
        if (this.textarea === '') {
          this.$message({
            duration: 2000,
            type: 'error',
            message: '请输入回答内容'
          })
          return false
        }
        this.$http.post('/apipx/Lesson/addinterlocution', {
          px_course_id: this.$parent.px_course_id,
          lesson_id: this.$parent.id,
          title: this.textarea,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.$message({
              duration: 2000,
              type: 'success',
              message: '提交成功'
            })
            this.getdata()
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .question {
    width: 360px;
    margin: 0 auto;
    overflow: hidden;

    .content {
      margin: 20px auto 0;

      .textarea {
        height: 20%;
        margin-top: 10%;

        textarea {
          height: 100%;

          &:focus {
            border: 1px solid #ff827b;
          }
        }
      }

      .rolling {
        height: 60%;
        overflow-x: hidden;
        overflow-y: scroll;

        &::-webkit-scrollbar {
          display: none;
        }

        .ul {
          overflow: hidden;

          li {
            height: 60px;
            padding: 10px 0;
            line-height: 30px;
            font-size: 14px;
            border-bottom: 1px solid #ebebeb;
            cursor: pointer;
            overflow: hidden;

            h5 {
              font-size: 16px;
              color: #ff827b;
              font-weight: bold;

              &:hover {
                text-decoration: underline;
              }
            }

            p {
              color: #919191;

              span {
                font-size: 14px;
                color: #ff827b;

                &:last-child {
                  color: #333;
                }
              }
            }
          }
        }
      }

      .sure {
        width: 110px;
        height: 40px;
        background-color: #ff8484;
        text-align: center;
        color: #fff;
        line-height: 40px;
        border-radius: 20px;
        cursor: pointer;
        margin: 20px 0 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/question/question.vue